






































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ModalEdit from '@/components/ModalEdit.vue';
import { CMProfile } from '@/models/cm-profile.model';
import { CMPRofileApi, _retrieveToken } from '@/services/api.service';
import { validationMixin } from 'vuelidate';
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators';
import { LANGUAGES_MAP } from '@/models/cm-languages.constant';


@Component({
 components: {
   ModalEdit,
 },
 mixins: [validationMixin],
  validations: {
    formData: {
        primaryLanguage: { required }
    }
 }
})

export default class ProfileLanguages extends Vue {

    public showEditDialog: boolean = false;
    public languagesFilled: boolean = false;
    public saving: boolean = false;

    public formData = {
        primaryLanguage: 'EN',
        otherLanguages: new Array()
    };

    @Prop({type: Boolean, default: false})
    public authorRequire;

    public get profile() {
        return this.$store.getters.profile;
    }

    public get languages() {
        return LANGUAGES_MAP;
    }

    public mounted() {
        this.__fillForm();
    }

    public handleModalClose() {
        this.showEditDialog = false;
    }

    public openModalEdit(event,id?: string) {
        this.__fillForm();
        this.showEditDialog = true;
    }

     public async updateLanguages() {
        this.$v.$touch();
        if (this.$v.$invalid) { return; }
        this.saving = true;
        this.__mapFormToProfile();
        try {
            this.profile.languages = await CMPRofileApi.updateLanguages(this.profile.languages);
            this.$store.commit('updateProfile', this.profile);
            this.showEditDialog = false;
        } catch (e) {
          console.error(e);
        } finally {
            this.saving = false;
        }
    }

    public getValidationClass(fieldName, forceInvalid = false) {
      const field = this.$v.formData[fieldName];
      if (field) {
        return {
          'md-invalid': (field.$invalid && field.$dirty) || forceInvalid
        };
      }
    }

    public addNewLanguage() {
        this.formData.otherLanguages.push('EN');
    }

    public removeOtherLanguage(index) {
        this.formData.otherLanguages.splice(index, 1);
    }

    private __fillForm() {
        if(this.profile.languages && this.profile.languages.length) {
            this.formData.primaryLanguage = this.profile.languages[0];
            this.formData.otherLanguages = this.profile.languages.slice(1);
            this.languagesFilled = true;
        }
    }

    private __mapFormToProfile() {
        const ll: string[] = [];
        ll.push(this.formData.primaryLanguage);
        ll.push(...this.formData.otherLanguages);
        this.profile.languages = ll;
    }


}

interface ILanguage {
    id: number;
    language: string;
}
